<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>耗材领用单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed bg-white">
            <span>领用信息</span>
        </div>
        <el-form :model="stuffAppturnVoucher" :rules="voucherRulesInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">领用日期</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="theDate">
                            <el-date-picker v-model="stuffAppturnVoucher.theDate" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">领用仓库</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="warehouseId">
                            <el-select v-model="stuffAppturnVoucher.warehouseId" @change="warehouseChange();">
                                <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <div class="inline-block mr10">
                            <el-form-item>
                                <el-checkbox v-model="audtoApplyState">自动申请</el-checkbox>
                            </el-form-item>
                        </div>
                        <div class="inline-block mr10" v-if="audtoApplyState">
                            <el-form-item>
                                <el-checkbox v-model="autoAuditPass">自动审核</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>耗材信息</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-button type="primary" @click="showDeviceListDlg()" :disabled="advancedData != null">通用选择</el-button>
                <!--<el-button type="primary" @click="showAdvancedDlg()" :disabled="stuffAppturnVoucher.stuffItemList.length > 0">-->
                <!--<span>快捷选择</span>-->
                <!--</el-button>-->
                <button class="swb-btn swb-btn-small ml10" :class="{'hidden' : advancedData == null}" @click="setStaff()">
                    <span>设置领用人</span>
                </button>
                <button class="swb-btn swb-btn-small" @click="setStaff" v-if="voucherId == null && stuffAppturnVoucher.stuffItemList != null && stuffAppturnVoucher.stuffItemList.length > 0">
                    <span>设置领用人</span>
                </button>
            </div>
        </div>
        <div v-if="advancedData != null">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">领用部门</label>
                    </div>
                    <div class="form-value">{{stuffAppturnVoucher.departName}}</div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">领用人</label>
                    </div>
                    <div class="form-value">{{stuffAppturnVoucher.staffName}}</div>
                </div>
            </div>
            <swb-asset-advanced-view :advancedData="advancedData" :clearAdvanced="clearAdvanced"></swb-asset-advanced-view>
        </div>
        <div v-if="advancedData == null">
            <div class="simple-row">
                <div class="right">
                    <span v-if="stuffAppturnVoucher.stuffItemList != null">已选择({{stuffAppturnVoucher.stuffItemList.length}})</span>
                </div>
            </div>
            <el-form :model="stuffAppturnVoucher" ref="stuffitemInfo">
                <div class="table-layout" style="width: 100%;overflow-x: auto">
                    <table class="custom-tbl error-prompt">
                        <thead class="head">
                        <tr class="row">
                            <th width="180" style="text-align: left;">耗材描述全称</th>
                            <th width="180" style="text-align: left;">耗材名称</th>
                            <th width="200" style="text-align: left;">型号</th>
                            <th width="200" style="text-align: left;">规格</th>
                            <th width="100" style="text-align: left;">分类</th>
                            <th width="100" style="text-align: left;">分类分组</th>
                            <th width="150" style="text-align: left;">品牌</th>
                            <th width="140" style="text-align: left;">责任部门</th>
                            <th width="140" style="text-align: left;">责任人</th>
                            <th width="130" class="required">领用部门</th>
                            <th width="100" class="required">领用人</th>
                            <th width="160" style="text-align: left;">批次号</th>
                            <th width="100" style="text-align: right;">可用数量</th>
                            <th width="100" style="text-align: right;">领用数量</th>
                            <th width="80">单位</th>
                            <th width="120" style="text-align: left;">备注</th>
                            <th width="150">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="(stuffItemInfo, index) in stuffAppturnVoucher.stuffItemList">
                            <td style="text-align: left;">{{stuffItemInfo.title}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.stuffName}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.model || ""}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.fixedSpec || ""}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.catName}}</td>
                            <td style="text-align: left;">{{getGoodsCatDevcGroupName(stuffItemInfo.catId)}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.brandName}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.principalDepartName}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.principalName}}</td>
                            <td>{{stuffItemInfo.departName}}</td>
                            <td>{{stuffItemInfo.staffName}}</td>
                            <td style="text-align: left;">{{stuffItemInfo.batchNo}}</td>
                            <td style="text-align: right;">{{stuffItemInfo.curAvQuantity}}</td>
                            <td style="text-align: right;">
                                <el-form-item :props="'stuffItemInfoList.' + index + '.quantity'" :rules="{validator: quantityChange, trigger: 'blur'}">
                                    <el-input class="text-right" type="number" v-model="stuffItemInfo.quantity" @change="changeQuantity(stuffItemInfo)"></el-input>
                                </el-form-item>
                            </td>
                            <td>{{stuffItemInfo.theUnit}}</td>
                            <td style="text-align: left;">
                                <el-input class="textarea-value" type="textarea" v-model="stuffItemInfo.memo"></el-input>
                            </td>
                            <td style="text-align: left;">
                                <a class="swb-btn-link" @click="deleteStuffInfo(index)">移除</a>
                                <a class="swb-btn-link" @click="setStaffInfo(index)">设置领用人</a>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot class="foot">
                        <tr v-if="stuffAppturnVoucher.stuffItemList == null || stuffAppturnVoucher.stuffItemList.length == 0">
                            <td colspan="16" style="text-align: center; line-height: 40px;">
                                <span class="font-gray3">暂无数据</span>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </el-form>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveAppturnVoucher">保存</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import{ showLowCostSelectDlg } from '../retailer/selectDlg'
    import{ openComStaffMainForSelectDlg } from '../orgStruct/selectDlg'
    import { openAssetAdvancedSelectDlg } from '../asset/selectDlg';
    import { getDevcGroupNameByCatId, syncSetBreadcrumb } from '../index'

    import shopStuffApi from '../../api/shopStuff'
    import userApi from '../../api/user'
    import shopStockApi from '../../api/shopStock'
    //
    import SwbStuffAppturnVoucherList from '../shopStuff/StuffAppturnVoucherList';
    Routes.add(SwbStuffAppturnVoucherList);

    import SwbAssetAdvancedView from '../asset/AssetAdvancedView';
    Vue.regist(SwbAssetAdvancedView);

    export default {
        name: 'swb-shop-stuff-appturn-voucher-save',
        path: '/shop/stuff/appturn/voucher/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: false,
        desc: '领用单 - 制作',
        data: function () {
            let validateTheDate = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择日期'));
                } else {
                    callback();
                }
            };
            let validateWarehouseId = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择仓库'));
                } else {
                    callback();
                }
            };
            return {
                stuffAppturnVoucher: {
                    theDate: new Date(),
                    warehouseId: null,
                    stuffItemList: []
                },
                warehouseList: [],
                merchantId: null,
                comId: null,
                voucherId: null,
                //
                scopeEntity: {},
                selectStaffInfo: {},
                audtoApplyState: true,
                autoAuditPass: true,
                //
                advancedData: null,       // 高级条件
                //
                voucherRulesInfo: {
                    theDate: [{validator: validateTheDate, trigger: 'blur'}],
                    warehouseId: [{validator: validateWarehouseId, trigger: 'blur'}]
                },
                parentPath: null,
            }
        },
        watch: {
            audtoApplyState: function (newVal, oldVal) {
                if(newVal != oldVal) {
                    this.autoAuditPass = false;
                }
            }
        },
        created: function () {
            syncSetBreadcrumb("制作领用单", SwbStuffAppturnVoucherList.path);
            //
            this.voucherId = this.$route.query.voucherId || null;
            //
            this.getCurrentUserInfo();
            this.getWarehouseList();
        },
        methods: {
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getCurrentUserInfo: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.merchantId = scopeEntity.id;
                        self.comId = scopeEntity.comId;
                        self.bizUnitId = scopeEntity.bizUnitId;
                        //
                        self.scopeEntity = scopeEntity;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 仓库信息
            getWarehouseList: function () {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.locked = false;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let warehouseList = result.data || [];
                        if(warehouseList.length > 0) {
                            warehouseList.forEach(function (row) {
                                if(row.defaulted == true) {
                                    self.stuffAppturnVoucher.warehouseId = row.id;
                                }
                            })
                        }
                        self.warehouseList = warehouseList;
                        //
                        if(!Utils.isNoB(self.voucherId)) {
                            self.getShopStuffAppturnVoucherInfo();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 仓库变化事件
            warehouseChange: function () {
                if(Utils.isNoB(this.voucherId)) {
                    this.stuffAppturnVoucher.stuffItemList = [];
                }
            },
            // 单原值校验
            inputOrgWorth: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 单净值校验
            inputNetWorth: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 领用数量
            quantityChange: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error("请输入领用数量"));
                } else {
                    if(value < 0) {
                        callback(new Error("不可小于0"));
                    } else {
                        callback();
                    }
                }
            },
            changeQuantity: function (durableItem) {
                let inStkAvQuantity = durableItem.inStkAvQuantity;
                let quantity = durableItem.quantity;
                //
                if(quantity > inStkAvQuantity) {
                    Toast.show(durableItem.title + "领用数量不能超过可用数量，可用数量为" + inStkAvQuantity);
                }
            },
            //
            getShopStuffAppturnVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffAppturnVoucherInfoByUpdate(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let stuffAppturnVoucher = result.data;
                        stuffAppturnVoucher.theDate = new Date();
                        //
                        self.stuffAppturnVoucher = Utils.merge({}, stuffAppturnVoucher);
                        //
                        let stuffItemList = [];
                        let itemList = stuffAppturnVoucher.stuffAppturnItemList || [];
                        if(itemList.length > 0) {
                            for(let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                stuffItemList.push(item);
                            }
                        }
                        self.stuffAppturnVoucher.stuffItemList = Utils.merge([], stuffItemList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 快捷选择
            showAdvancedDlg(){
                let self = this;
                let stuffAppturnVoucher = this.stuffAppturnVoucher;
                if(stuffAppturnVoucher.stuffItemList.length > 0 || stuffAppturnVoucher.stuffItemList.length > 0) {
                    MsgBox.warning("请清空耗材信息后再试");
                    return;
                }
                let warehouseId = stuffAppturnVoucher.warehouseId;
                if(Utils.isNoB(warehouseId)) {
                    Toast.show("请选择仓库");
                    return;
                }
                let batchFilter = {
                    lowCostFlag: true
                };
                let advancedData = self.advancedData || {};
                // 耗材的高级选择
                let params = {
                    retailerShopId: self.bizUnitId,
                    warehouseId: warehouseId,
                    showSingle: false,
                    showBatchComn: false,
                    showBatchLow: true,
                    showCat: true,
                    showKind: false,
                    showDepart: false,
                    showAcctEnterWay: true,
                    resultFilter: advancedData.resultFilter || null,
                    batchFilter: batchFilter
                };
                openAssetAdvancedSelectDlg(params, function (advancedData) {
                    let scopeEntity = self.scopeEntity;
                    let stuffAppturnVoucher = self.stuffAppturnVoucher;
                    stuffAppturnVoucher.departId = scopeEntity.departId;
                    stuffAppturnVoucher.departName = scopeEntity.departName;
                    stuffAppturnVoucher.staffId = scopeEntity.staffId;
                    stuffAppturnVoucher.staffName = scopeEntity.staffName;
                    self.stuffAppturnVoucher = Utils.merge({}, stuffAppturnVoucher);
                    //
                    self.advancedData = advancedData;
                });
            },
            // 高级条件删除
            clearAdvanced: function () {
                let stuffAppturnVoucher = this.stuffAppturnVoucher;
                stuffAppturnVoucher.departId = null;
                stuffAppturnVoucher.departName = null;
                stuffAppturnVoucher.staffId = null;
                stuffAppturnVoucher.staffName = null;
                this.stuffAppturnVoucher = Utils.merge({}, stuffAppturnVoucher);
                //
                this.advancedData = null;
            },
            // 通用选择-耗材信息
            showDeviceListDlg: function () {
                let self = this;
                let warehouseId = self.stuffAppturnVoucher.warehouseId;
                if(Utils.isNoB(warehouseId)) {
                    Toast.show("请选择领用仓库");
                    return false;
                }
                let stuffItemList = self.stuffAppturnVoucher.stuffItemList || [];
                let selectBatchIds = stuffItemList.pluck("stuffId");
                let params = {
                    filter: {
                        retailerShopId: self.bizUnitId,
                        warehouseId: warehouseId,
                        assetReturn: false
                    },
                    selectioned: true,
                    selectIds: selectBatchIds
                };
                showLowCostSelectDlg(params, function (resultData) {
                    let itemList = resultData || [];
                    //
                    let stuffAppturnVoucher = self.stuffAppturnVoucher;
                    let stuffItemList = stuffAppturnVoucher.stuffItemList || [];
                    itemList.forEach(function (stuffInfo) {
                        let item = self.makeStuffItemInfo(stuffInfo);
                        //
                        stuffItemList.push(item);
                    });
                    stuffAppturnVoucher.stuffItemList = Utils.merge([], stuffItemList);
                    self.stuffAppturnVoucher = Utils.merge({}, stuffAppturnVoucher);
                })
            },
            makeStuffItemInfo: function (stuffItem) {
                let item = {};
                let scopeEntity = this.scopeEntity;
                if(!Utils.isNoB(stuffItem)) {
                    item.devcDefId = stuffItem.devcDefId;
                    item.stuffId = stuffItem.id;
                    item.catName = stuffItem.catName;
                    item.catId = stuffItem.catId;
                    item.brandId = stuffItem.brandId;
                    item.brandName = stuffItem.brandName;
                    item.title = stuffItem.title;
                    item.stuffName = stuffItem.name;
                    item.model = stuffItem.model;
                    item.fixedSpec = stuffItem.fixedSpec;
                    item.modelSpec = stuffItem.modelSpec;
                    item.acctEnterWay = stuffItem.acctEnterWay;
                    item.principalDepartName = stuffItem.departName;
                    item.principalName = stuffItem.principalName;
                    item.curAvQuantity = stuffItem.curAvQuantity;
                    item.quantity = 1;
                    item.batchNo = stuffItem.batchNo;
                    item.theUnit = stuffItem.theUnit;
                    item.memo = stuffItem.memo;
                    item.orgWorth = stuffItem.orgWorth;
                    item.netWorth = stuffItem.netWorth;
                    //
                    item.departId = scopeEntity.departId;
                    item.departName = scopeEntity.departName;
                    item.staffId = scopeEntity.staffId;
                    item.staffName = scopeEntity.staffName;
                }
                // 优先设备上的责任人为领用人
                let departId = stuffItem.departId;
                let principalId = stuffItem.principalId;
                if(!Utils.isNoB(departId) && !Utils.isNoB(principalId)) {
                    item.departId = departId;
                    item.departName = stuffItem.departName;
                    //
                    item.staffId = principalId;
                    item.staffName = stuffItem.principalName;
                }
                return item;
            },
            deleteStuffInfo: function (index) {
                let stuffItemList = this.stuffAppturnVoucher.stuffItemList || [];
                stuffItemList.splice(index, 1);
                //
                this.stuffAppturnVoucher.stuffItemList = Utils.merge([], stuffItemList);
            },
            // 设置人员
            setStaff: function () {
                let self = this;
                let bizUnitId = self.bizUnitId;
                if(!Utils.isNoB(self.advancedData)) {
                    let stuffAppturnVoucher = self.stuffAppturnVoucher;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: self.comId}, function (result, theDlg) {
                        theDlg.close();
                        stuffAppturnVoucher.departId = result.srcComId;
                        stuffAppturnVoucher.departName = result.srcComName;
                        stuffAppturnVoucher.staffId = result.id;
                        stuffAppturnVoucher.staffName = result.name;
                        self.stuffAppturnVoucher = Utils.merge({}, stuffAppturnVoucher);
                    });
                } else {
                    let stuffItemList = self.stuffAppturnVoucher.stuffItemList;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: self.comId}, function (result, theDlg) {
                        theDlg.close();
                        stuffItemList.forEach(function (durableAppturnItem) {
                            durableAppturnItem.departId = result.srcComId;
                            durableAppturnItem.departName = result.srcComName;
                            durableAppturnItem.staffId = result.id;
                            durableAppturnItem.staffName = result.name;
                        });
                        self.stuffAppturnVoucher.stuffItemList = Utils.merge([], stuffItemList);
                    });
                }
            },
            // 单行设置人员
            setStaffInfo: function (index) {
                let self = this;
                let bizUnitId = self.bizUnitId;
                let stuffItemList = self.stuffAppturnVoucher.stuffItemList;
                openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: self.comId}, function (result, theDlg) {
                    theDlg.close();
                    let durableAppturnItem = stuffItemList[index];
                    durableAppturnItem.departId = result.srcComId;
                    durableAppturnItem.departName = result.srcComName;
                    durableAppturnItem.staffId = result.id;
                    durableAppturnItem.staffName = result.name;
                    //
                    self.stuffAppturnVoucher.stuffItemList = Utils.merge([], stuffItemList);
                });
            },
            //返回
            prevStock: function () {
                let self = this;
                self.$router.back(-1);
            },
            // 保存固定资产领用/归还单
            saveAppturnVoucher: function () {
                let theLoad = MsgBox.loading();
                let self = this;
                let stuffAppturnVoucher = self.stuffAppturnVoucher;
                if(stuffAppturnVoucher.theDate != null) {
                    stuffAppturnVoucher.theDate = stuffAppturnVoucher.theDate.format('yyyy-MM-dd');
                }
                self.warehouseList.forEach(function (warehouse) {
                    if(warehouse.id == stuffAppturnVoucher.warehouseId) {
                        stuffAppturnVoucher.warehouseName = warehouse.name;
                    }
                });
                stuffAppturnVoucher.autoApplyState = self.audtoApplyState;
                stuffAppturnVoucher.autoAuditPass = self.autoAuditPass;
                //
                if(this.advancedData != null) {
                    if(Utils.isNoB(stuffAppturnVoucher.departId) || Utils.isNoB(stuffAppturnVoucher.staffId)) {
                        Toast.show("请设置领用部门，领用人");
                        theLoad.close();
                        return;
                    }
                    stuffAppturnVoucher.isAdvanced = true;
                    stuffAppturnVoucher.filterItems = this.advancedData.resultFilter || null;
                    //
                    self.doReqSaveAppturnVoucher(stuffAppturnVoucher);
                } else {
                    self.$refs['ruleForm'].validate(function (valid) {
                        if(valid) {
                            let stuffItemList = stuffAppturnVoucher.stuffItemList || [];
                            if(stuffItemList.length <= 0 && stuffItemList.length <= 0) {
                                Toast.show("请选择耗材");
                                theLoad.close();
                                return;
                            }
                            // 有耐用品的时候进行耐用品相关的校验
                            if(stuffItemList.length > 0) {
                                let validateFailure = false;
                                self.$refs['stuffitemInfo'].validate(function (valid) {
                                    if(valid) {
                                        for(let i = 0; i < stuffItemList.length; i++) {
                                            let item = stuffItemList[i];
                                            if(Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                                validateFailure = true;
                                                Toast.show("请为耗材设置人员");
                                                break;
                                            }
                                            if(Utils.isNoB(item.quantity)) {
                                                validateFailure = true;
                                                Toast.show("请设置领用数量");
                                                break;
                                            }
                                            if(!Utils.isNoB(item.quantity) && item.quantity == 0) {
                                                validateFailure = true;
                                                Toast.show("领用数量，不可为0");
                                                break;
                                            }
                                            let curAvQuantity = item.curAvQuantity;
                                            if(item.quantity > curAvQuantity) {
                                                validateFailure = true;
                                                Toast.show(item.title + "领用数量不能超过可用数量，可用数量为" + curAvQuantity);
                                                break;
                                            }
                                        }
                                    } else {
                                        validateFailure = true;
                                        Toast.show("请输入耗材中相应的数据！");
                                    }
                                });
                                if(validateFailure) {
                                    theLoad.close();
                                    return false;
                                }
                            }
                            if(stuffItemList.length > 500) {
                                MsgBox.warning("【耗材】支持最大单据级条目为500条！现" + stuffItemList.length + "条！");
                                theLoad.close();
                                return;
                            }
                            stuffAppturnVoucher.stuffAppturnItemList = stuffItemList;
                            self.doReqSaveAppturnVoucher(stuffAppturnVoucher);
                        }
                    });
                }
                theLoad.close();
            },
            doReqSaveAppturnVoucher: function (stuffAppturnVoucher) {
                let self = this;
                if(Utils.isNoB(stuffAppturnVoucher.id)) {
                    let theLoad = MsgBox.loading();
                    shopStuffApi.doStuffAppturnVoucherSave(stuffAppturnVoucher, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("保存成功");
                            self.$router.push({
                                path: SwbStuffAppturnVoucherList.path
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let theLoad = MsgBox.loading();
                    shopStuffApi.doStuffAppturnVoucherUpdate(stuffAppturnVoucher, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("保存成功");
                            self.$router.push({
                                path: SwbStuffAppturnVoucherList.path
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopStuff/StuffAppturnVoucherSave.vue